import "./App.css";
import NavigationBar from "./components/Navbar";
import Intro from "./components/Intro";
import "./style/landingpage.css";
import Trending from "./components/Trending";
import Anime from "./components/Anime";

function App() {
  return (
    <div>
      {/* Intro Section */}
      <div className="myBG">
        <NavigationBar />
        <Intro />
      </div>

      {/* Trending Section */}
      <div className="trending">
        <Trending />
      </div>

      {/* Anime Section */}
      <div className="anime">
        <Anime />
      </div>
    </div>
  );
}

export default App;
